import { useRef, useState, useEffect } from 'react';
import { ReportingContainerBaseConfig } from '../../../../../base';
import { TextElementController } from './textElementInterface';
import { TextElementContainerProps } from './textElementProps';

export function createTextElementContainer(
    config: ReportingContainerBaseConfig,
    controller: TextElementController
): React.FC<TextElementContainerProps> {
    return ({ as: View, ...containerProps }) => {
        const initialValue = containerProps.value;
        const containerRef = useRef<HTMLDivElement>(null);
        const [value, setValue] = useState(initialValue);
        const [editing, setEditing] = useState(false);

        // Sync local state with prop changes
        useEffect(() => {
            setValue(containerProps.value);
        }, [containerProps.value]);
        const props = controller.useProps({
            containerRef: containerRef,
            isEditing: editing,
            field: {
                isDirty: value !== initialValue,
                value: value,
                onChange: setValue,
            },
            format: containerProps.format,
            onEdit() {
                setEditing(true);
            },
            onSubmit(value) {
                setEditing(false);
                setValue(value);
                containerProps.onChange(value);
            },
            onCancel() {
                // Reset to original value when user cancels (Escape key)
                setValue(initialValue);
                setEditing(false);
            },
            onBlur() {
                // Save current value on blur instead of resetting
                setEditing(false);
                containerProps.onChange(value);
            },
        });

        return <View {...props} />;
    };
}
